import React from 'react'
import { fromJSX, Updater, Widget } from 'widgets-for-react'
import { EmptyLayout } from './emptyLayout'
import { EmptyState } from './emptyState'

export const emptyWidget = (_: EmptyState): Widget<Updater<EmptyState>> =>
  fromJSX(() => <EmptyLayout />)
